import styled from 'styled-components';
import * as DesignSystem from '../../../assets/styles/StyleTypes';

interface ContainerProps {
  isSelected: boolean;
}

export const Container = styled.div<ContainerProps>`
  border-radius: ${DesignSystem.BorderRadius.XS};
  width: 15px;
  height: 15px;
  background: ${({ isSelected }) => (isSelected ? DesignSystem.Colors.PRIMARY_PURE : 'white')};
  border: 1px solid ${DesignSystem.Colors.PRIMARY_PURE};
  //box-shadow: ${DesignSystem.Shadow.LIGHT_BOX_SHADOW};
  cursor: pointer;
`;

export const ImageCheck = styled.img`
  width: 14px !important;
  height: 14px !important;
`;